import { SwapOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import React from 'react';

const { Option } = Select;

enum EStore {
  MI_FAN = 'mi-fan',
  MI_KHAY = 'mi-khay',
  MI_CLUSTER = 'mi-cluster',
}

interface StoreOption {
  label: string;
  value: EStore;
  url: string;
  urlProduction: string;
}

const storeOptions: StoreOption[] = [
  {
    label: 'Mi Fan',
    value: EStore.MI_FAN,
    url: 'https://mi-fan-dev.oscarlash.com',
    urlProduction: 'https://qlsx.oscarlash.com/login',
  },
  {
    label: 'Mi Khay',
    value: EStore.MI_KHAY,
    url: 'https://mi-khay-dev.oscarlash.com',
    urlProduction: 'https://mi-khay.oscarlash.com',
  },
  {
    label: 'Mi Cluster',
    value: EStore.MI_CLUSTER,
    url: 'https://mi-cluster-dev.oscarlash.com',
    urlProduction: 'https://mi-cluster.oscarlash.com',
  },
];

const SwitchStore: React.FC = () => {
  const [selectedStore, setSelectedStore] = React.useState<any>(process.env.REACT_APP_STORE_TYPE);

  const handleStoreChange = (value: EStore) => {
    const selectedOption = storeOptions.find((option) => option.value === value);
    if (selectedOption) {
      const url =
        process.env.REACT_APP_ENVIRONMENT === 'production' ? selectedOption.urlProduction : selectedOption.url;
      window.open(url, '_blank');
    }
  };

  return (
    <div className="switch-store">
      <Select
        value={selectedStore}
        onChange={handleStoreChange}
        placeholder="Chọn loại"
        style={{ width: 120 }}
        suffixIcon={<SwapOutlined />}
        size="large"
      >
        {storeOptions.map((option) => (
          <Option key={option.value} value={option.value}>
            <div className="store-option">
              <span className="store-label">{option.label}</span>
            </div>
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default SwitchStore;
